import { Plus, RefreshCw, Search } from "lucide-react";

import BrandCreateModal from "./brand-create-modal";
import Datatable from "@components/datatable";
import LoadingButton from "@components/ui-components/loading-button";
import useSuperadminBrands from "../hooks/use-superadmin-brands";
import { getBrandColumns } from "../misc/columns";

const BrandsPanel = () => {
    const {
        rows, total, loading, search, setSearch,
        createOpen, methods, openCreate, closeCreate, submit, regenerateExtId, refresh
    } = useSuperadminBrands();

    return (
        <div>
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                    <h2 className="text-lg font-semibold text-gray-900">Brands</h2>
                    <p className="text-sm text-muted">
                        {`${total} brand(s). `}
                        Each row carries the <code className="rounded bg-light px-1.5 py-0.5 text-xs text-gray-700">api_key</code>
                        {" and "}
                        <code className="rounded bg-light px-1.5 py-0.5 text-xs text-gray-700">ext_id</code>
                        {" that step 3 creates its logins with."}
                    </p>
                </div>
                <div className="flex items-center gap-2">
                    <LoadingButton color="neutral" size="sm" icon={RefreshCw} text="Refresh" onClick={refresh} />
                    <LoadingButton size="sm" icon={Plus} text="Create brand" onClick={openCreate} />
                </div>
            </div>

            <div className="relative mt-4 max-w-sm">
                <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" />
                <input
                    type="text"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    placeholder="Search name, external id or status"
                    className="w-full rounded-lg border border-gray-300 py-2.5 pl-9 pr-3 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20" />
            </div>

            <div className="mt-4 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                <Datatable
                    columns={getBrandColumns()}
                    data={rows}
                    loading={loading}
                    defaultLimit={25}
                    customNoData={<span className="text-sm text-muted">No brands yet.</span>} />
            </div>

            <BrandCreateModal
                open={createOpen}
                methods={methods}
                loading={loading}
                onClose={closeCreate}
                onSubmit={submit}
                onRegenerateExtId={regenerateExtId} />
        </div>
    );
};

export default BrandsPanel;
